import { render, staticRenderFns } from "./OptionsCard.vue?vue&type=template&id=3fadf02a&"
import script from "./OptionsCard.vue?vue&type=script&lang=ts&"
export * from "./OptionsCard.vue?vue&type=script&lang=ts&"
import style0 from "./OptionsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
